module.exports = __webpack_public_path__ + "static/media/beverage-drink-soda-svgrepo-com.72100548.svg";